import { render, staticRenderFns } from "./NoticeVariationWithText.vue?vue&type=template&id=89cedc56&scoped=true"
import script from "./NoticeVariationWithText.vue?vue&type=script&lang=js"
export * from "./NoticeVariationWithText.vue?vue&type=script&lang=js"
import style0 from "./NoticeVariationWithText.vue?vue&type=style&index=0&id=89cedc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cedc56",
  null
  
)

export default component.exports